<template>
  <transition name="bbp-bounce">
    <div
      v-if="hover === row.id || showToolbar"
      class="bbp-toolbar"
    >
      <i
        v-if="row.disabled"
        class="bbp-toolbar-copy"
        @click.stop="setCopyItem"
      >
        <BBPIconCopy/>
      </i>
      <i
        v-if="displayEditIcon && !row.disabled"
        class="bbp-icon-edit bbp-toolbar-icon"
        @click.stop="setEditItem"
      />
      <BBPCompleteProject
        v-if="displayCompletedIcon && !row.disabled"
        :row="row"
        :rows="rows"
        :column="column"
        @change-status="updateItem"
      />
      <i
        class="bbp-icon-remove bbp-toolbar__icon bbp-toolbar-icon bbp-toolbar-icon_red"
        @click.stop="setOpenDelete($event, true)"
      >
        <transition name="bbp-bounce">
          <div
            v-if="deleteOpen"
            class="bbp-toolbar-confirm"
            @click.stop
            :style="popupPosition"
            v-click-outside="closeConfirmDelete"
            @mouseleave="closeConfirmDelete"
          >
            <div class="bbp-toolbar-confirm__text">Are you sure?</div>
            <div class="bbp-toolbar-confirm-controls">
              <button class="bbp-button bbp-toolbar-confirm-controls__button" @click.stop="deleteItem">yes</button>
              <button class="bbp-button bbp-toolbar-confirm-controls__button" @click.stop="closeConfirmDelete">no
              </button>
            </div>
          </div>
        </transition>
      </i>
      <transition name="bbp-fade">
        <BBPDoubleDelete
          v-if="openDoubleDelete"
          :id="row.id"
          :title="`Do you want to delete ${row.name}`"
          @close="openDoubleDelete = false"
          @delete="deleteForever"
        />
      </transition>
    </div>
  </transition>
</template>

<script>
import BBPDoubleDelete from '@/components/Main/BBPDoubleDelete/BBPDoubleDelete'
import BBPCompleteProject from '@/components/Main/BBPTable/BBPCompleteProject/BBPCompleteProject'
import {IN_PROGRESS_PROJECT} from '@/constants/projectStatuses'
import BBPIconCopy from '@/components/Main/BBPIcons/BBPIconCopy'

export default {
  name: 'BBPToolbarTable',
  props: ['row', 'rows', 'column', 'index', 'hover', 'right', 'isHowUpdate', 'showToolbar'],
  components: {
    BBPDoubleDelete,
    BBPCompleteProject,
    BBPIconCopy
  },
  data () {
    return {
      openDoubleDelete: false,
      deleteOpen: false,
      popupPosition: {},
      currentElement: {}
    }
  },
  computed: {
    displayEditIcon () {
      const { showEdit = false } = this.column
      return this.row.status === IN_PROGRESS_PROJECT.id || showEdit
    },
    displayCompletedIcon () {
      const { showComplete = false } = this.column
      return this.row.status || showComplete
    },
    isDoubleDelete () {
      const { isDoubleDelete = false } = this.column
      return isDoubleDelete
    }
  },
  methods: {
    updateItem ({row, column, value}) {
      this.$emit('update', {row, column, value})
    },
    closeConfirmDelete () {
      this.popupPosition = {}
      this.deleteOpen = false
    },
    deleteItem () {
      this.currentElement = {row: this.row, column: this.column, index: this.index}
      if (this.isDoubleDelete) {
        this.openDoubleDelete = true
        return
      }
      this.deleteForever()
    },
    deleteForever () {
      this.$emit('delete', this.currentElement)
    },
    setEditItem () {
      const currentElem = {row: this.row, column: this.column, index: this.index}
      this.$emit('edit', currentElem)
      this.closeConfirmDelete()
    },
    setCopyItem () {
      const currentElem = {row: this.row, column: this.column, index: this.index}
      this.$emit('copy', currentElem)
      this.closeConfirmDelete()
    },
    setOpenDelete (e, val) {
      this.deleteOpen = val
      const position = e.target.getBoundingClientRect()
      if (val && position) {
        this.popupPosition = {
          position: 'fixed',
          top: position.top + 'px',
          right: 'auto',
          left: this.right ? position.left + 30 + 'px' : position.left - 127 + 'px'
        }
      } else {
        this.popupPosition = {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bbp-toolbar {
  display: grid;
  grid-template-columns: repeat(auto-fill, 21px);
  grid-gap: 10px;

  &-copy {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 21px;
    height: 21px;
    background: $color-wild-sand;
    border-radius: 50%;
  }

  &__icon {
    position: relative;
  }

  &-icon_orange {
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color-yellow-orange;
    background: $color-wild-sand;
    border-radius: 50%;
    font-size: 11px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPToolbarTable/BBPToolbarTable.vue